// Recently-used custom colors store.
// Persists up to MAX hex colors in localStorage, newest first.
// Pending mechanism: a custom color picked via the color input is held as
// "pending" and only committed to recents when the user actually draws with
// it (via commitPendingIfMatch called on pointerdown).
//
// ES5-friendly (no optional chaining etc.).

import {PALETTE} from './colors';

const KEY = 'suttu.recents';
const MAX = 5;

var listeners = [];
var pendingHex = null;

function loadFromStorage() {
    try {
        var raw = window.localStorage.getItem(KEY);
        if (!raw) return [];
        var arr = JSON.parse(raw);
        if (!Array.isArray(arr)) return [];
        return arr.filter(function(x) {
            return typeof x === 'string' && /^#[0-9a-f]{6}$/i.test(x);
        }).slice(0, MAX);
    } catch (_) {
        return [];
    }
}

function saveToStorage(arr) {
    try {
        window.localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (_) {}
}

var recents = loadFromStorage();

function notify() {
    for (var i = 0; i < listeners.length; i++) {
        try { listeners[i](); } catch (_) {}
    }
}

export function getRecents() {
    return recents.slice();
}

export function subscribeRecents(fn) {
    listeners.push(fn);
    return function unsubscribe() {
        var idx = listeners.indexOf(fn);
        if (idx >= 0) listeners.splice(idx, 1);
    };
}

function isPresetHex(hex) {
    var lower = hex.toLowerCase();
    for (var i = 0; i < PALETTE.length; i++) {
        if (PALETTE[i].toLowerCase() === lower) return true;
    }
    return false;
}

export function addRecent(hex) {
    if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return;
    var lower = hex.toLowerCase();
    if (isPresetHex(lower)) return; // never duplicate presets
    // Dedupe + push to front
    var next = [lower];
    for (var i = 0; i < recents.length && next.length < MAX; i++) {
        if (recents[i].toLowerCase() !== lower) next.push(recents[i]);
    }
    recents = next;
    saveToStorage(recents);
    notify();
}

export function setPendingCustom(hex) {
    if (!hex) { pendingHex = null; return; }
    pendingHex = hex.toLowerCase();
}

// Called when a stroke begins. If the current draw color matches the pending
// custom color, commit it to recents.
export function commitPendingIfMatch(hex) {
    if (!pendingHex || !hex) return;
    if (hex.toLowerCase() !== pendingHex) return;
    var captured = pendingHex;
    pendingHex = null;
    addRecent(captured);
}
